const currenciesObject = {
  AUD: {
    name: 'Australian Dollar',
    symbol: '$',
    flag: 'AU'
  },
  BGN: {
    name: 'Bulgarian Lev',
    symbol: 'лв',
    flag: 'BG'
  },
  BRL: {
    name: 'Brazilian real',
    symbol: 'R$',
    flag: 'BR'
  },
  CAD: {
    name: 'Canadian Dollar',
    symbol: '$',
    flag: 'CA'
  },
  CHF: {
    name: 'Swiss Franc',
    symbol: 'Fr',
    flag: 'CH'
  },
  CNY: {
    name: 'Chinese Renminbi Yuan',
    symbol: '¥',
    flag: 'CN'
  },
  CZK: {
    name: 'Czech Koruna',
    symbol: 'Kč',
    flag: 'CZ'
  },
  DKK: {
    name: 'Danish Krone',
    symbol: 'kr',
    flag: 'DK'
  },
  EUR: {
    name: 'Euro',
    symbol: '€',
    flag: 'EU'
  },
  GBP: {
    name: 'British Pund',
    symbol: '£',
    flag: 'GB'
  },
  HKD: {
    name: 'Hong Kong Dollar',
    symbol: '$',
    flag: 'HK'
  },
  HRK: {
    name: 'Croatian Kuna',
    symbol: 'kn',
    flag: 'HR'
  },
  HUF: {
    name: 'Hungarian Forint',
    symbol: 'Ft',
    flag: 'HU'
  },
  IDR: {
    name: 'Indonesian Tupiah',
    symbol: 'Rp',
    flag: 'ID'
  },
  ILS: {
    name: 'Israeli New Sheqel',
    symbol: '₪',
    flag: 'IL'
  },
  INR: {
    name: 'Indian Rupee',
    symbol: '₹',
    flag: 'IN'
  },
  ISK: {
    name: 'Icelandic Króna',
    symbol: 'kr',
    flag: 'IS'
  },
  JPY: {
    name: 'Japanese Yen',
    symbol: '¥',
    flag: 'JP'
  },
  KRW: {
    name: 'South Korean Won',
    symbol: '₩',
    flag: 'KR'
  },
  MXN: {
    name: 'Mexican Peso',
    symbol: '$',
    flag: 'MX'
  },
  MYR: {
    name: 'Malaysian Ringgit',
    symbol: 'RM',
    flag: 'MY'
  },
  NOK: {
    name: 'Norwegian Krone',
    symbol: 'kr',
    flag: 'NO'
  },
  NZD: {
    name: 'New Zealand Dollar',
    symbol: '$',
    flag: 'NZ'
  },
  PHP: {
    name: 'Philippine Peso',
    symbol: '₱',
    flag: 'PH'
  },
  PLN: {
    name: 'Polish Złoty ',
    symbol: 'zł',
    flag: 'PL'
  },
  RON: {
    name: 'Romanian Leu',
    symbol: 'lei',
    flag: 'RO'
  },
  SEK: {
    name: 'Swedish Krona',
    symbol: 'kr',
    flag: 'SE'
  },
  SGD: {
    name: 'Singapore Dollar',
    symbol: '$',
    flag: 'SG'
  },
  THB: {
    name: 'Thai Baht',
    symbol: '฿',
    flag: 'TH'
  },
  TRY: {
    name: 'Turkish Lira',
    symbol: '₺',
    flag: 'TR'
  },
  USD: {
    name: 'United States Dollar',
    symbol: '$',
    flag: 'US'
  },
  ZAR: {
    name: 'South African Rand',
    symbol: 'R',
    flag: 'ZA'
  },
}

export default currenciesObject;